import React from "react";
import { Card, Form, Checkbox, Divider, Button, InputNumber, Col, Row, Modal, Input, message } from 'antd';

import NHFetch from "../../../utils/NHFetch";
import NHSelect from "../../common/NHSelect";
import NHFormItem from '../../common/NHFormItem';
import { getLoginUser } from "../../../utils/NHCore";
import PropTypes from 'prop-types';
import {NHModal, NHConfirm} from '../../common/NHModal';

const FormItem = Form.Item;
const CheckboxGroup = Checkbox.Group;
const { TextArea } = Input;
const basicUrl = "/yxxc/";
const hjdm = "GD001";   //环节代码
const jfxtBasicUrl = 'api/zhxg-jfxt/';

/**
 * 绿色通道
 * Author: zengxiangkai@ly-sky.com
 * Created on: 2018-06-26
 * Version: 1.0
 * Modify log:
 */
class Lstd extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            editable: true,
            show: false,
            lstdBlyy: [], //绿色通道办理原因列表
            hjblztData: {}, //环节办理状态信息
            lstdData: {}, //学生绿色通道办理信息
            yjje: 0,
            studentData: {},
            loading: false,
            previewVisible: false,
            judgeImgList: ['.png', '.PNG', '.jpg', '.JPG', '.bpm', '.BPM', '.jpeg', '.JPEG'],   //可以导入的图片格式
            dkyhmc: '',
            dkyhList: []
        }
    }

    //渲染前获取 绿色通道办理原因
    componentDidMount() {
        this.getLstdBlyy();
        this.getDmkMc("YXWZ_DKYH");
    }

    componentWillReceiveProps(nextProps) {

        if ('studentData' in nextProps) {
            const studentData = nextProps.studentData;

            //查询到学生信息时才显示绿色通道环节办理业务项
            if (Object.keys(studentData).length !== 0) {

                //查询到不同学生，查找该学生应缴费用
                if (JSON.stringify(this.state.studentData) === '{}' || this.state.studentData !== studentData) {
                    this.setState({ studentData: studentData });
                    this.getLstdYjjeData(studentData);
                    this.getLstdData(studentData);
                }
                this.setState({ show: true });

            } else {
                this.setState({ show: false });
            }
        }

        if ('hjblztData' in nextProps) {
            const hjblztData = nextProps.hjblztData;
            const lstdData = this.state.lstdData;

            if (hjblztData) {
                this.setState({ hjblztData: hjblztData});
            } else {
                this.setState({ hjblztData: hjblztData});
            }
            if (lstdData.sjly == 2) {
                this.setState({ editable: false });
            }

        }

    }


    //获取下拉列表value对应的名称
    getDmkMc = (dmbz) => {
        NHFetch(basicUrl + "getDmkMc", "GET", { dmbz, dmbz })
            .then(res => {
                if (res) {
                    if (res.data) {
                        if (dmbz === "YXWZ_DKYH") {

                            this.setState({ dkyhList: res.data });
                        }
                    }
                }
            });
    }

    /**
     * 获取贷款银行名称
     */
    getDkyhMc(lstdData) {
        let dkyhmc = '';
        this.state.dkyhList.map(initItem => {
            if (initItem.DM === lstdData.dkyh) {
                dkyhmc = initItem.MC;
            }
        });
        this.setState({ dkyhmc: dkyhmc });
    }


    /**
     * * 获取学生应缴费用信息
     *
     * @memberof Lstd
     */
    getLstdYjjeData = (studentData) => {
        const { xsid } = studentData;
        NHFetch(jfxtBasicUrl + 'yxjk/getTotalYjje', 'GET', { xsid: xsid })
            .then(res => {
                if (res && res.data) {
                    this.setState({ yjje: res.data });
                } else {
                    this.setState({ yjje: 0 });
                }
            })
    }

    /**
     * * 获取绿色通道办理原因
     *
     * @memberof Lstd
     */
    getLstdBlyy = () => {
        NHFetch(basicUrl + "getLstdBlyy", "GET")
            .then(res => {
                if (res) {
                    if (res.data) {
                        let col = [];
                        res.data.map(item => {
                            col.push(
                                <Col span={12}>
                                    <Checkbox value={item.VALUE}>
                                        {item.LABEL}
                                    </Checkbox>
                                </Col>
                            );
                        });
                        let html = <Row>{col}</Row>
                        this.setState({
                            lstdBlyy: html,
                        });
                    }
                }
            });
    }

    /**
     * * 获取学生绿色通道办理数据
     *
     * @memberof Lstd
     */
    getLstdData = (studentData) => {
        const { xsid } = studentData;
        NHFetch(basicUrl + 'getLstdData', 'GET', { xsid: xsid })
            .then(res => {
                if (res && res.data) {
                    this.setState({ lstdData: res.data , editable: false });
                    this.getDkyhMc(res.data);

                }else if(res.data == null){
                    this.setState({lstdData: {} , editable: true });

                }

            }).catch((ress) => {
                this.setState({ lstdData: {}, dkyhmc: '无' });
            })
    }


    //确认办理
    handleSubmit = () => {

        const { xsid } = this.props.studentData;

        if (!xsid) {
            message.error("环节办理失败,请先查询学生信息！");
            return;
        }

        const form = this.props.form;

        //校验
        form.validateFields((err, formData) => {

            if (err) {
                return;
            }
            if (this.state.lstdData.sjly != '2') {
                let blyy = formData['blyy'];
                let sqsm = formData['sqsm'];
                let dkyh = formData['dkyh'];
                let hzjym = formData['hzjym'];
                let sqsmFlag = false;
                let msg = '';
                blyy.map(item => {
                    if (item == '99') {
                        if (typeof (sqsm) == "undefined" || sqsm.trim().length == 0) {
                            sqsmFlag = true;
                            msg = "其它原因，请填写申请理由"
                        }
                    }
                })

                if (dkyh == '01') {
                    if (typeof (hzjym) == "undefined" || hzjym.trim().length != 6) {
                        sqsmFlag = true;
                        msg = "国家开发银行贷款，请填写6位数回执校验码"
                    }
                }
                if (sqsmFlag) {
                    message.error(msg);
                    return;
                }
            }

            const { pkid } = this.state.hjblztData;
            const { xsid } = this.state.studentData;
            let userId = getLoginUser() ? getLoginUser().userId : '';
            let params = { xsid: xsid, lchjid: pkid, formData: formData, yhbh: userId, hjdm: hjdm };

            this.setState({ loading: true })
            NHFetch(basicUrl + 'saveCustomLinkData', 'POST', params)
                .then(res => {
                    if (res) {
                        if (res.data == '1') {
                            this.setState({ loading: false })
                            message.success('环节办理成功！');
                            this.getLstdData(this.state.studentData);
                            //办理完成回调
                            const onFinish = this.props.onFinish;
                            if (onFinish) {
                                onFinish('submit');
                            }
                        } else {
                            this.setState({ loading: false })
                            message.error('环节办理失败，请重试！');
                        }
                    }
                    this.setState({ loading: false })
                })
        });
    }

    //取消办理
    handleCancel = () => {
        const { pkid } = this.state.hjblztData;
        const { xsid } = this.state.studentData;

        let params = { xsid: xsid, hjdm: hjdm, lchjid: pkid };
        NHConfirm("是否确定取消办理？",() => {
            this.setState({ loading: true })
            NHFetch(basicUrl + 'cancelCustomLinkData', 'POST', params)
                .then(res => {
                    if (res) {
                        if (res.data == '1') {
                            this.setState({ loading: false })
                            message.success('环节办理取消成功！');
                            //取消办理完成回调
                            this.getLstdData(this.state.studentData);
                            const onFinish = this.props.onFinish;
                            if (onFinish) {
                                onFinish('cancel');
                            }
                        } else {
                            this.setState({ loading: false })
                            message.error('环节办理取消失败，请重试！');
                        }
                    }
                })
        },"warn");
    }

    //打印报到单回调
    handlePrint = () => {
        let onPrint = this.props.onPrint;
        if (onPrint) {
            onPrint();
        }
    }

    //上一步
    handleLast = () => {
        let onLast = this.props.onLast;
        if (onLast) {
            onLast();
        }
    }

    //下一步
    handleNext = () => {
        let onNext = this.props.onNext;
        if (onNext) {
            onNext();
        }
    }

    //判断文件类型是否正常  name：文件名称  map：类型范围数组
    setJudge = (name, map) => {
        let flag = false;
        map.map(item => {
            if (name.indexOf(item) !== -1) {
                flag = true;
            }
        })
        return flag;
    }


    // 点击文件链接或预览图标时的回调
    handlePreview = (fjmc, fjid) => {
        let isImage = this.setJudge(fjmc, this.state.judgeImgList);

        if (isImage) {
            this.showPreview(`api/docrepo/download/file?attachmentId=${fjid}`);
        } else {
            window.open(`api/docrepo/download/file?attachmentId=${fjid}`);
        }
    };

    //打开图片弹窗
    showPreview = (url) => {
        this.setState({
            previewImage: url,
            previewVisible: true
        });
    }
    // 关闭图片弹窗
    closeModal = () => this.setState({ previewVisible: false });


    render() {

        const { form, lchjData = {}, hasLast, hasNext } = this.props;
        const { editable, lstdBlyy, show, lstdData, yjje, loading, previewVisible, previewImage, dkyhmc } = this.state;

        const { sfdybdd = '0' } = lchjData; //是否打印报到单

        const formItemLayout = { //表单项布局
            labelCol: {
                xs: { span: 24 },
                sm: { span: 12 },
                md: { span: 10 },
                lg: { span: 4 },
            },
            wrapperCol: {
                xs: { span: 24 },
                sm: { span: 12 },
                md: { span: 10 },
                lg: { span: 8 },
            }
        }

        return (

            <div>

                <Card type="inner" title="绿色通道业务信息">
                    {
                        editable ?
                            <div>
                                {
                                    show ?
                                        <Form>
                                            <NHFormItem id={"blyy"} label="办理原因" form={form} required={true}
                                                formItemLayout={formItemLayout}>
                                                <Checkbox.Group
                                                    style={{ width: '100%' }}
                                                >
                                                    {lstdBlyy}
                                                </Checkbox.Group>
                                            </NHFormItem>
                                            <NHFormItem id={"yjje"} formItemLayout={formItemLayout} form={form}
                                                label={'应缴费用'}>
                                                <span>{yjje}</span>
                                            </NHFormItem>

                                            <NHFormItem id={"hjje"} label="贷款金额" form={form} required={true}
                                                formItemLayout={formItemLayout}>
                                                <InputNumber
                                                    style={{ width: '50%' }}
                                                    formatter={value => `￥ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                                    parser={value => value.replace(/\￥\s?|(,*)/g, '')}
                                                    // max={yjje}
                                                    max={99999999}
                                                    min={0}
                                                    step={100}
                                                />
                                            </NHFormItem>

                                            <NHFormItem id={"dkyh"} label="贷款银行" form={form} required={true}
                                                formItemLayout={formItemLayout}>
                                                <NHSelect style={{ width: '50%' }} sign={"dmk_yxwz_dkyh"} />
                                            </NHFormItem>

                                            <NHFormItem id={"hzjym"} label="6位数回执校验码" form={form}
                                                formItemLayout={formItemLayout}>
                                                <Input style={{ width: '50%' }} maxLength={6} placeholder="6位数回执校验码" />
                                            </NHFormItem>

                                            <NHFormItem id={"sqsm"} label="申请理由" form={form}
                                                formItemLayout={formItemLayout}>
                                                <TextArea maxLength={50} placeholder="请填写申请理由" />
                                            </NHFormItem>
                                        </Form>
                                        : null
                                }
                            </div>
                            :
                            <div>
                                <Form>
                                    <FormItem {...formItemLayout} label={'办理原因'}>
                                        <span>{lstdData.blyy}</span>
                                    </FormItem>
                                    <FormItem {...formItemLayout} label={'应缴金额'}>
                                        <span>{yjje}</span>
                                    </FormItem>
                                    <FormItem {...formItemLayout} label={'贷款金额'}>
                                        <span>{lstdData.blje}</span>
                                    </FormItem>
                                    <FormItem {...formItemLayout} label={'贷款银行'}>
                                        <span>{dkyhmc}</span>
                                    </FormItem>
                                    <FormItem {...formItemLayout} label={'6位数回执校验码'}>
                                        <span>{lstdData.hzjym}</span>
                                    </FormItem>
                                    <FormItem {...formItemLayout} label={'申请理由'}>
                                        <span>{lstdData.sqsm}</span>
                                    </FormItem>

                                    {lstdData.fj == null ? null :

                                        <FormItem {...formItemLayout} label={'申请材料附件'}>
                                            <span>{lstdData.fj.map((elem, index) => {
                                                return (
                                                    <div style={{ marginBottom: '20px' }}>
                                                        <a onClick={() => {
                                                            this.handlePreview(elem['fjmc'], elem['fjid']);
                                                        }}>{elem['fjmc']}</a>
                                                    </div>
                                                )
                                            })}</span>
                                        </FormItem>}

                                </Form>

                                <Modal
                                    visible={previewVisible}
                                    footer={null}
                                    onCancel={this.closeModal}
                                >
                                    <img
                                        alt="example"
                                        style={{ width: '100%' }}
                                        src={previewImage}
                                    />
                                </Modal>

                            </div>
                    }
                </Card>
                <Divider style={{ margin: '40px 0 24px' }} />
                {
                    editable || (lstdData.shzt == 0 || lstdData.shzt == 9) ?
                        <Button type="primary" onClick={this.handleSubmit} loading={loading}>确认办理</Button>
                        : <Button type="primary" onClick={this.handleCancel} loading={loading}>取消办理</Button>
                }
                {
                    sfdybdd == '1' ? <Button type="primary" loading={this.props.loading} ghost style={{ marginLeft: 10 }} onClick={this.handlePrint}>打印报到单</Button> : null
                }
                {
                    hasLast ? <Button type="primary" ghost style={{ marginLeft: 10 }} onClick={this.handleLast}>上一步</Button> : null
                }
                {
                    hasNext ? <Button type="primary" ghost style={{ marginLeft: 10 }} onClick={this.handleNext}>下一步</Button> : null
                }
            </div>
        )
    }
}

Lstd.propTypes = {
    studentData: PropTypes.object, //学生信息
    hjblztData: PropTypes.object, //环节办理状态信息
    lchjData: PropTypes.object, //流程环节信息数据
    hasLast: PropTypes.bool, //是否有上一步
    hasNext: PropTypes.bool, //是否有下一步
    onLast: PropTypes.func, //上一步事件回调
    onNext: PropTypes.func, //下一步事件回调
    onFinish: PropTypes.func, //确认办理、取消办理完成回调
    onPrint: PropTypes.func, //打印报到单
}

const lstd = Form.create()(Lstd);
export default lstd


// WEBPACK FOOTER //
// ./components/yxxc/steps/lstd.js